export enum Steps {
    MATERIAL = 'MATERIAL',
    DIMENSIONS = 'DIMENSIONS',
    LIST_UPLOAD = 'LIST_UPLOAD',
    WEIGHT_PRICE = 'WEIGHT_PRICE',
    PICKUP_ADDRESS = 'PICKUP_ADDRESS',
    DELIVERY_INFO = 'DELIVERY_INFO',
}
